import { notification } from 'antd';
import axios, { AxiosResponse } from 'axios';
import { formatDate } from '/react4xp/mixins/helpers';
import { TData } from '/react4xp/parts/find-taxpayer-service/find-taxpayer-service.type';

const urlSync = `/services/isnaportalsync/open-api/taxpayer-data`;

export const urlPrint = '/services/isnaportalsync/open-api/taxpayer-data';

export const getTaxPayerInfo = (
    request: any,
    secretKey?: any,
    token?: any
): Promise<AxiosResponse> => {
    let query = '?';
    if (secretKey) query += `token=${secretKey}`;

    return axios
        .get(urlSync, {
            params: {
                taxpayerCode: request.iinBin,
                firstName: request.firstName,
                lastName: request.lastName,
                name: request.organizationName,
                taxpayerType: request.type,
            },
        })
        .then((response) => {
            if (response.data.errorResponse?.errorMessage) {
                notification['warning']({
                    message: response.data.errorResponse?.errorMessage,
                });
            }

            return response;
        })
        .then((response) => {
            if (
                response.data.taxpayerPortalSearchResponses &&
                response.data.taxpayerPortalSearchResponses.length > 0
            ) {
                const rawDataList = response.data.taxpayerPortalSearchResponses || [];

                if (['IP', 'UL'].includes(request.type)) {
                    return {
                        ...response,
                        data: { taxpayers: getIpUlTaxPayerInfo(rawDataList, request.type) },
                        total: 1,
                    };
                }

                const groupedMap = new Map<string, TData>();

                rawDataList.forEach((taxpayer) => {
                    let iinBin = taxpayer.code;
                    if (['IP', 'UL'].includes(request.type) && !request.iinBin) {
                        iinBin = '';
                    }

                    let rows = [];
                    if (taxpayer.taxpayerType === 'LZCHP' && Array.isArray(taxpayer.lzchpTypes)) {
                        rows = taxpayer.lzchpTypes.map((typeItem) => ({
                            beginDate: typeItem.beginDate,
                            endDate: typeItem.endDate,
                            lzchpType: typeItem.lzchpType,
                            reason: taxpayer.additionalInfo?.ru || '',
                            rnn: iinBin,
                            suspensionPeriod:
                                taxpayer.additionalInfo?.beginDate &&
                                taxpayer.additionalInfo?.endDate
                                    ? `${formatDate(
                                          taxpayer.additionalInfo.beginDate
                                      )} - ${formatDate(taxpayer.additionalInfo.endDate)}`
                                    : '',
                            ulTaxInfo: [],
                            endReason: typeItem.endReason,
                            additionalInfoDocument: taxpayer.additionalInfoDocument
                                ? {
                                      ...taxpayer.additionalInfoDocument,
                                      date: formatDate(taxpayer.additionalInfoDocument.date),
                                  }
                                : null,
                        }));
                    } else {
                        rows = [
                            {
                                beginDate: taxpayer.beginDate,
                                endDate: taxpayer.endDate,
                                lzchpType: taxpayer.taxpayerType,
                                reason: taxpayer.additionalInfo?.ru || '',
                                rnn: iinBin,
                                suspensionPeriod:
                                    taxpayer.additionalInfo?.beginDate &&
                                    taxpayer.additionalInfo?.endDate
                                        ? `${formatDate(
                                              taxpayer.additionalInfo.beginDate
                                          )} - ${formatDate(taxpayer.additionalInfo.endDate)}`
                                        : '',
                                ulTaxInfo: [],
                                endReason: taxpayer.endReason,
                                additionalInfoDocument: taxpayer.additionalInfoDocument
                                    ? {
                                          ...taxpayer.additionalInfoDocument,
                                          date: formatDate(taxpayer.additionalInfoDocument.date),
                                      }
                                    : null,
                            },
                        ];
                    }

                    if (groupedMap.has(iinBin)) {
                        groupedMap.get(iinBin)!.rows.push(...rows);
                    } else {
                        groupedMap.set(iinBin, {
                            iinBin,
                            name: getTaxpayerName(taxpayer),
                            type: taxpayer.taxpayerType,
                            rows,
                        });
                    }
                });

                const groupedList: TData[] = Array.from(groupedMap.values());

                return {
                    ...response,
                    data: { taxpayers: groupedList },
                    total: 1,
                };
            }

            return response;
        });
};

const getTaxpayerName = (taxpayer: any): string | undefined => {
    if (taxpayer?.name) {
        return taxpayer.name;
    }

    if (taxpayer?.taxpayerName) {
        return taxpayer.taxpayerName;
    }

    const { lastName, firstName, middleName } = taxpayer?.fullName || {};

    if (lastName && firstName && middleName) {
        return `${lastName} ${firstName} ${middleName}`;
    }

    if (lastName && firstName && !middleName) {
        return `${lastName} ${firstName}`;
    }

    return undefined;
};

const getIpUlTaxPayerInfo = (data: any, type: string): TData[] => {
    const rows = [];
    data.forEach((taxpayer, index) => {
        rows.push({
            rowNumber: index + 1,
            name: taxpayer.name,
            type: taxpayer.taxpayerType,
            iinBin: taxpayer.code,
            beginDate: taxpayer.beginDate,
            endDate: taxpayer.endDate,
            endReason: taxpayer.endReason,
            additionalInfoDocument: taxpayer.additionalInfoDocument
                ? {
                      ...taxpayer.additionalInfoDocument,
                      date: formatDate(taxpayer.additionalInfoDocument.date),
                  }
                : null,
            suspensionPeriod:
                taxpayer.additionalInfo?.beginDate && taxpayer.additionalInfo?.endDate
                    ? `${formatDate(taxpayer.additionalInfo.beginDate)} - ${formatDate(
                          taxpayer.additionalInfo.endDate
                      )}`
                    : '',
        });
    });

    return [
        {
            iinBin: data[0]?.code || '',
            name: getTaxpayerName(data[0]),
            type,
            rows,
        },
    ];
};
